'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const EditIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="EditIcon">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4248_29265)">
          <path
            d="M5.80508 18.3196L0.416748 19.5837L1.68091 14.1962L14.9701 0.905386C15.1249 0.75055 15.3086 0.627724 15.5109 0.543924C15.7131 0.460124 15.9299 0.416992 16.1488 0.416992C16.3678 0.416992 16.5845 0.460124 16.7868 0.543924C16.989 0.627724 17.1728 0.75055 17.3276 0.905386L19.0959 2.67289C19.2508 2.82766 19.3736 3.01142 19.4574 3.21367C19.5412 3.41593 19.5843 3.63271 19.5843 3.85164C19.5843 4.07056 19.5412 4.28734 19.4574 4.4896C19.3736 4.69185 19.2508 4.87561 19.0959 5.03039L5.80508 18.3196Z"
            stroke="rgba(61, 81, 123, 0.5)"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.5084 5.62081L14.3809 1.49414"
            stroke="rgba(61, 81, 123, 0.5)"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.3192 6.81035L13.2017 2.67285"
            stroke="rgba(61, 81, 123, 0.5)"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.01514 18.1113L1.89014 13.9863"
            stroke="rgba(61, 81, 123, 0.5)"
            strokeWidth="0.833333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

EditIcon.propTypes = {
  sx: PropTypes.object
}
